import Vue from "vue";
import {Constructor} from "../../../global/constructor";
import {Hash} from "../../interfaces/hashInterfaces";
import {ObjectHelper} from "../../helpers/objectHelper";
import ElementHandler from "../../services/elementHandler";
import TrackedModel from "../tracked/trackedModel";
import {ArrayHelper} from "../../helpers/arrayHelper";
import {IFilterElementContainer, ISortableFilterElement} from "../../interfaces/contentManagementInterfaces";
import {ListViewFilterLayoutElementType} from "../../enums/listViews/listViewFilterLayoutElementType";
import ListViewFilterElement from "../listViews/elements/listViewFilterElement";

interface IFilterElementable<TFilterElement>{
  rootModel: TrackedModel;
  filter_elements: Hash<TFilterElement>;
  _filterElementHandler: ElementHandler;
  _classKey: string;
  // _collectionKey: string;

  deepFilterElementsArray: TFilterElement[];
}

export default function FilterElementable<TBase extends
                                               Constructor,
                                           TFilterElement extends
                                               ISortableFilterElement &
                                               TrackedModel,
                                           TContainer extends
                                               TrackedModel &
                                               IFilterElementContainer<TFilterElement> &
                                               TFilterElement>(Base: TBase) {
  return class extends Base implements IFilterElementable<TFilterElement> {
    rootModel: TrackedModel;
    filter_elements: Hash<TFilterElement>= {};
    _filterElementHandler: ElementHandler;
    _classKey: string;
    // _collectionKey: string;

    get classKey(): string {
      return this._classKey;
    }

    get filterElementHandler(): ElementHandler {
      return this._filterElementHandler;
    }

    get filterElementsArray(): TFilterElement[] {
      return ObjectHelper.toArray(this.filter_elements)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get deepFilterElementsArray(): TFilterElement[] {
      const elements = [];
      for (const el of this.filterElementsArray) {
        elements.push(el);
        if (el instanceof ListViewFilterElement) {
          elements.push(...el.deepFilterElementsArray);
        }
      }
      return elements;
    }

    get hasFilterElements(): boolean {
      return this.filterElementsArray.length > 0;
    }

    get lastFilterElementInSortOrder(): TFilterElement {
      return ArrayHelper.last(this.filterElementsArray);
    }

    initializeEmbedded(parent: TContainer, item: TFilterElement , position: number, json: object = {}) {
      if (parent.filter_type !== ListViewFilterLayoutElementType.Grid) {
        item.elementHandler.updateElementPositions(parent, item, position);
      }
      parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
      item.addToRepo();
      item.select();

      Vue.set(parent[item.rootName], item.client_id, item);
      return item;
    }
  }
}